<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件类型" prop="bpbjType">
              <j-dict-select-tag dictCode="bpbj_type" type="radioButton" v-model="model.bpbjType" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :rules="[{ required: model.bpbjType == 2, message: '设备类型不能为空', trigger: 'blur' }]"
              :wrapperCol="wrapperCol"
              label="适配设备类型"
              prop="devClassCode"
            >
              <j-tree-select-custom
                @change="classChange"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="model.devClassCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件名称" prop="bjName">
              <a-input placeholder="请输入备件名称" v-model="model.bjName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :rules="[{ required: model.bpbjType == 2, message: '设备型号不能为空', trigger: 'blur' }]"
              :wrapperCol="wrapperCol"
              label="适配设备型号"
              prop="devModelId"
            >
              <j-multi-select-tag
                :dictCode="modelSelectDictCode"
                @change="modelSelectChange"
                placeholder="请选择适配设备型号"
                v-model="model.devModelId"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件型号" prop="bjModel">
              <a-input placeholder="请输入备件型号" v-model="model.bjModel"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应备数量" prop="prepareCount">
              <a-input-number placeholder="请输入应备数量" style="width: 100%" v-model="model.prepareCount" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备件型号规格" prop="bjModelSpec">
              <a-input placeholder="请输入备件型号规格" v-model="model.bjModelSpec"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="初始库存" prop="leftCount">
              <a-input-number placeholder="请输入初始库存" style="width: 100%" v-model="model.leftCount" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产厂家" prop="manuId">
              <j-search-select-tag
                :getPopupContainer="getModalAsContainer"
                dict="`iwt-wf`.common_manufacturer,manu_name,id, 1=1 order by manu_name asc"
                placeholder="请选择生产厂家"
                v-model="model.manuId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单位" prop="unit">
              <a-input placeholder="请输入计量单位" v-model="model.unit"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- age_month -->
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="寿命（月）" prop="ageMonth">
              <a-input-number placeholder="请输入寿命" v-model="model.ageMonth"></a-input-number>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { initDictOptions, filterDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'DevBpbjInfoForm',
    components: {},
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          bpbjType: '2',
          prepareCount: 0,
          leftCount: 0,
          ageMonth: 12
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          bjName: [{ required: true, message: '请输入备件名称!' }],
          bjModel: [{ required: true, message: '请选择备件型号!' }],
          bpbjType: [{ required: true, message: '请选择备件类型!' }],
          prepareCount: [{ required: true, message: '请输入应备数量!' }]
        },
        devClassList: [],
        devModelList: [],
        url: {
          add: '/spareparts/devBpbjInfo/add',
          edit: '/spareparts/devBpbjInfo/edit',
          queryById: '/spareparts/devBpbjInfo/queryById',
          selectClass: '/device/devClass/selectDropList',
          queryModelById: '/device/devModel/queryById'
        },
        manuList: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      modelSelectDictCode () {
        return this.model.devClassCode
          ? `\`iwt-wf\`.dev_model,model_name,id,dev_class_code like '${this.model.devClassCode}%25' order by model_name`
          : '`iwt-wf`.dev_model,model_name,id, 1=1 order by model_name'
      }
    },
    watch: {
      'model.bpbjType': function (val) {
        if (val && val === '2') {
          this.$refs.form.clearValidate('receiver')
        }
      }
    },
    async created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      // this.getClassList()
    },
    methods: {
      classChange (v) { },
      modelSelectChange (modelId) {
        getAction(this.url.queryModelById, { id: modelId }).then(res => {
          this.model.manuId = this.model.manuId || res.result?.manuId
        })
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      manuSelected (record) {
        this.model.manuName = record[0].manuName
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!that.model.id) {
              httpurl += that.url.add
              method = 'post'
            } else {
              httpurl += that.url.edit
              method = 'put'
            }

            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      getClassList () {
        getAction(this.url.selectClass, {}).then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      getModalAsContainer (node) {
        return document.querySelector('.j-modal-box .ant-modal-content')
      }
    }
  }
</script>
